import { styled, Typography } from "@mui/material";

export const WidgetDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
}));

WidgetDescription.defaultProps = {
  variant: "body2",
};
